import React from "react";
import { withRouter } from "react-router-dom";
import Header from "./common/Header.js";
import Footer from "./common/Footer.js";
import api from "./api/Api.js";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Select from "react-select";
import SelectChecked from "./images/SelectChecked.svg";
import SelectUnchecked from "./images/SelectUnchecked.svg";

class Refer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: {},
      errorMessage: false,
      id: props.match.params.id,
      firstName: "",
      lastName: "",
      birthDay: "",
      birthMonth: "",
      birthYear: "",
      phone: "",
      zip: "",
      memberId: "",
      planName: "",
      reason: "",
      isTaskTransportationSelected: false,
      isTaskFoodSelected: false,
      isTaskSocialIsolationSelected: false,
      isTaskHospitalizationSelected: false,
      caregiverFirstName: "",
      caregiverLastName: "",
      caregiverEmail: "",
      caregiverPhone: "",
      caregiverRelationship: "",
      isSubmitting: false,
      showConfirmation: false,
    };

    // Re-routing to newer marketing webpage.
    window.location.href = "https://www.getduos.com";
  }

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  handleSelectChange = (event) => {
    this.setState({ caregiverRelationship: event.value });
  };

  handleTaskSelection = (t) => {
    if (t === "transportation") {
      this.setState({ isTaskTransportationSelected: !this.state.isTaskTransportationSelected });
    } else if (t === "food") {
      this.setState({ isTaskFoodSelected: !this.state.isTaskFoodSelected });
    } else if (t === "recent hospitalization") {
      this.setState({ isTaskHospitalizationSelected: !this.state.isTaskHospitalizationSelected });
    } else if (t === "social isolation") {
      this.setState({ isTaskSocialIsolationSelected: !this.state.isTaskSocialIsolationSelected });
    }
  };

  errorHandler = (e) => {
    return this.state.errors[e] ? { borderColor: "red", filter: "drop-shadow(0px 0px 3px red)" } : {};
  };

  sectionConfirmation = () => {
    return (
      <div id="about" className="section wide img light confirmation">
        <div className="wrap confirmation">
          <h2 className="heading-4 confirm" style={{ marginBottom: "20px" }}>
            Thanks for your referral!
            <br />
          </h2>
          <div className="confirmationcontainer w-container">
            <h2 className="paragraph-2 confirmation">
              We can’t wait to help you with all of your member needs.
              <br />
            </h2>

            <h2 style={{ marginBottom: "10px" }} className="paragraph-2 orange">
              What comes next?
              <br />
            </h2>
            <div className="roundStepsContainer" style={{ margin: "10px" }}>
              <div className="roundSteps">1</div>
            </div>
            <h2 style={{ width: "63%", marginBottom: "30px" }} className="paragraph-2 confirmation">
              A DUOS team member will give the member a call to talk about their needs and our services. <br />
            </h2>
            <div className="roundStepsContainer" style={{ margin: "10px" }}>
              <div className="roundSteps">2</div>
            </div>
            <h2 style={{ width: "63%" }} className="paragraph-2 confirmation">
              The member will be matched with a Duo.
              <br />
            </h2>
          </div>
          <a href={"/refer/" + this.state.id} className="button-hero sub w-button">
            Refer New Member
          </a>
        </div>
      </div>
    );
  };

  sectionMemberInformation = () => {
    return (
      <div className="section wide img light gray apply">
        <div className="memberpod">
          <h2 className="heading-5 lightbg leftheading" style={{ marginBottom: "5px" }}>
            Let’s get to know the member
          </h2>
          <p className="caption">This helps us personalize our services.</p>
          <div className="w-container">
            <div className="contact-form-grid-2">
              <div>
                <label htmlFor="firstName" className="field-label left">
                  First Name
                </label>
                <input
                  value={this.state.firstName}
                  onChange={this.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={this.errorHandler("firstName")}
                  maxLength="256"
                  name="firstName"
                  placeholder=""
                  id="firstName"
                  required="required"
                />
              </div>
              <div>
                <label htmlFor="lastName" className="field-label">
                  Last Name
                </label>
                <input
                  value={this.state.lastName}
                  onChange={this.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={this.errorHandler("lastName")}
                  maxLength="256"
                  name="lastName"
                  placeholder=""
                  id="lastName"
                  required="required"
                />
              </div>
            </div>
            <div>
              <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2", whiteSpace: "nowrap" }}>
                <label htmlFor="birthMonth" className="field-label">
                  Date of Birth
                </label>
                <div>
                  <input
                    value={this.state.birthMonth}
                    onChange={this.handleChange}
                    type="text"
                    className="text-field memberinput w-input"
                    style={Object.assign(
                      { display: "inline-block", width: "75px", marginRight: "20px" },
                      this.errorHandler("birthMonth")
                    )}
                    maxLength="2"
                    name="birthMonth"
                    placeholder="MM"
                    id="birthMonth"
                    required="required"
                    inputMode="numeric"
                    pattern="\s*\d*\s*"
                  />
                  <input
                    value={this.state.birthDay}
                    onChange={this.handleChange}
                    type="text"
                    className="text-field memberinput w-input"
                    style={Object.assign(
                      { display: "inline-block", width: "75px", marginRight: "20px" },
                      this.errorHandler("birthDay")
                    )}
                    maxLength="2"
                    name="birthDay"
                    placeholder="DD"
                    id="birthDay"
                    required="required"
                    inputMode="numeric"
                    pattern="\s*\d*\s*"
                  />
                  <input
                    value={this.state.birthYear}
                    onChange={this.handleChange}
                    type="text"
                    className="text-field memberinput w-input"
                    style={Object.assign(
                      { display: "inline-block", width: "125px", marginRight: "20px" },
                      this.errorHandler("birthYear")
                    )}
                    maxLength="4"
                    name="birthYear"
                    placeholder="YYYY"
                    id="birthYear"
                    required="required"
                    inputMode="numeric"
                    pattern="\s*\d*\s*"
                  />
                </div>
              </div>
              <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
                <label htmlFor="phone" className="field-label">
                  Their Phone Number
                </label>
                <input
                  value={this.state.phone}
                  onChange={this.handleChange}
                  type="tel"
                  className="text-field memberinput w-input"
                  style={Object.assign({ width: "100%", maxWidth: "500px" }, this.errorHandler("phone"))}
                  maxLength="256"
                  name="phone"
                  placeholder="555-555-5555"
                  id="phone"
                  required="required"
                />
              </div>

              <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2", marginBottom: "40px" }}>
                <label htmlFor="zip" className="field-label">
                  Their Zip Code
                </label>
                <input
                  value={this.state.zip}
                  onChange={this.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={Object.assign({ marginBottom: "0px", width: "200px" }, this.errorHandler("zip"))}
                  maxLength="256"
                  name="zip"
                  placeholder=""
                  id="zip"
                  required="required"
                  inputMode="numeric"
                  pattern="\s*\d*\s*"
                />
                <label htmlFor="zip" className="caption">
                  Duos is personalized based on location.
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  sectionCaregiverInformation = () => {
    const relationshipOptions = [
      { value: "My Parent", label: "Their Parent" },
      { value: "My Friend", label: "Their Friend" },
      { value: "My Relative", label: "Their Relative" },
      { value: "Caregiver", label: "Caregiver" },
    ];

    const dropdownIndicatorStyles = (base, state) => {
      let changes = {
        // all your override styles
        color: "#4f196f",
      };
      return Object.assign(base, changes);
    };

    const singleValueStyles = (base, state) => {
      let changes = {
        // all your override styles
        color: "#4f196f",
      };
      return Object.assign(base, changes);
    };

    const optionStyles = (base, state) => {
      let changes = {
        // all your override styles
        color: state.isFocused ? "#ffffff" : "#4f196f",
        backgroundColor: state.isFocused ? "#4f196f" : "#ffffff",
        ":hover": {
          backgroundColor: "#4f196f",
          color: "#fff",
        },
      };
      return Object.assign(base, changes);
    };

    const menuStyles = (base, state) => {
      let changes = {
        // all your override styles
        display: "block",
        color: "#4f196f",
        fontSize: "18px",
        fontWeight: "700",
      };
      return Object.assign(base, changes);
    };

    const controlStyles = (base, state) => {
      let changes = {
        // all your override styles
        width: "100%",
        maxWidth: "500px",
        height: "55px",
        borderStyle: "solid",
        borderWidth: "2px",
        borderColor: "#4f196f",
        borderRadius: "4px",
        backgroundColor: "#fff",
        color: "#4f196f",
        fontSize: "18px",
        fontWeight: "700",
        whiteSpace: "normal",
        backgroundClip: "border-box",
        boxShadow: "",
        ":focus": {
          borderColor: "#4f196f",
          boxShadow: "0 0 0 1px #4f196f",
        },
        ":focus-within": {
          borderColor: "#4f196f",
          boxShadow: "0 0 0 1px #4f196f",
        },
        ":hover": {
          borderColor: "#4f196f",
          boxShadow: "0 0 0 1px #4f196f",
        },
        ":active": {
          boxShadow: "0 0 0 1px #4f196f",
        },
      };
      return Object.assign(base, changes, this.errorHandler("relationship"));
    };

    return (
      <div className="section wide img light gray apply">
        <div className="memberpod">
          <h2 className="heading-5 lightbg leftheading" style={{ marginBottom: "5px" }}>
            Is there a caregiver? (optional)
          </h2>
          <p className="caption">
            Tell us if someone else will be speaking on behalf of the member. (ie. family member, friend, etc).
          </p>
          <div className="w-container">
            <div className="contact-form-grid-2">
              <div className="collapseMobile">
                <label htmlFor="caregiverFirstName" className="field-label left">
                  Caregiver First Name
                </label>
                <input
                  value={this.state.caregiverFirstName}
                  onChange={this.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={this.errorHandler("caregiverFirstName")}
                  maxLength="256"
                  name="caregiverFirstName"
                  placeholder=""
                  id="caregiverFirstName"
                />
              </div>
              <div className="collapseMobile">
                <label htmlFor="caregiverLastName" className="field-label">
                  Caregiver Last Name
                </label>
                <input
                  value={this.state.caregiverLastName}
                  onChange={this.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={this.errorHandler("caregiverLastName")}
                  maxLength="256"
                  name="caregiverLastName"
                  placeholder=""
                  id="caregiverLastName"
                />
              </div>
            </div>
            <div>
              <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
                <label htmlFor="caregiverPhone" className="field-label">
                  Caregiver Phone Number
                </label>
                <input
                  value={this.state.caregiverPhone}
                  onChange={this.handleChange}
                  type="tel"
                  className="text-field memberinput w-input"
                  style={Object.assign({ width: "100%", maxWidth: "500px" }, this.errorHandler("caregiverPhone"))}
                  maxLength="256"
                  name="caregiverPhone"
                  placeholder="555-555-5555"
                  id="caregiverPhone"
                />
              </div>

              <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
                <label htmlFor="caregiverEmail" className="field-label">
                  Caregiver Email
                </label>
                <input
                  value={this.state.caregiverEmail}
                  onChange={this.handleChange}
                  type="email"
                  className="text-field memberinput w-input"
                  style={Object.assign({ width: "100%", maxWidth: "500px" }, this.errorHandler("caregiverEmail"))}
                  maxLength="256"
                  name="caregiverEmail"
                  placeholder=""
                  id="caregiverEmail"
                />
              </div>

              <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
                <label htmlFor="caregiverRelationship" className="field-label">
                  Relationship to member
                </label>
                <Select
                  options={relationshipOptions}
                  placeholder="Select relationship"
                  inputProps={{ readOnly: true }}
                  isSearchable={false}
                  onChange={this.handleSelectChange}
                  value={relationshipOptions.filter((option) => option.value === this.state.caregiverRelationship)}
                  components={{ IndicatorSeparator: () => null }}
                  styles={{
                    option: optionStyles,
                    menu: menuStyles,
                    control: controlStyles,
                    dropdownIndicator: dropdownIndicatorStyles,
                    singleValue: singleValueStyles,
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  insuranceInformation = () => {
    return (
      <div className="section wide img light gray apply">
        <div className="memberpod">
          <h2 className="heading-5 lightbg leftheading" style={{ marginBottom: "5px" }}>
            Health Insurance Information (optional)
          </h2>
          <p className="caption">This helps us better understand program eligibility.</p>
          <div className="w-container">
            <div>
              <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
                <label htmlFor="memberId" className="field-label">
                  Member Id
                </label>
                <input
                  value={this.state.memberId}
                  onChange={this.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={Object.assign({ width: "100%", maxWidth: "500px" }, this.errorHandler("memberId"))}
                  maxLength="256"
                  name="memberId"
                  placeholder="NOH##########"
                  id="memberId"
                />
              </div>

              <div style={{ gridColumnStart: "span 2", gridColumnEnd: "span 2" }}>
                <label htmlFor="planName" className="field-label">
                  Plan Name
                </label>
                <input
                  value={this.state.planName}
                  onChange={this.handleChange}
                  type="text"
                  className="text-field memberinput w-input"
                  style={Object.assign({ width: "100%", maxWidth: "500px" }, this.errorHandler("planName"))}
                  maxLength="256"
                  name="planName"
                  placeholder=""
                  id="planName"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  sectionTasks = () => {
    return (
      <div className="section wide img light gray apply">
        <div className="memberpod">
          <h2 className="heading-5 lightbg leftheading" style={{ marginBottom: "5px" }}>
            How can we help the member? (optional)
          </h2>
          <p className="caption">Select all that apply.</p>

          <div className="boxSelect">
            <div style={{ flex: "0 0 50%", position: "relative", textAlign: "center" }}>
              <button
                className="selectButton"
                style={
                  this.state.isTaskTransportationSelected
                    ? { backgroundColor: "#4F196F", color: "#ffffff" }
                    : { backgroundColor: "#ffffff", color: "#4F196F" }
                }
                onClick={(ev) => {
                  ev.preventDefault();
                  this.handleTaskSelection("transportation");
                }}
              >
                Transportation
                <img
                  alt="unchecked"
                  src={SelectUnchecked}
                  style={{ display: this.state.isTaskTransportationSelected ? "none" : "block" }}
                  className="selectUnchecked"
                />
                <img
                  alt="checked"
                  src={SelectChecked}
                  style={{ display: this.state.isTaskTransportationSelected ? "block" : "none" }}
                  className="selectChecked"
                />
              </button>
            </div>
            <div style={{ flex: "0 0 50%", position: "relative", textAlign: "center" }}>
              <button
                className="selectButton"
                style={
                  this.state.isTaskFoodSelected
                    ? { backgroundColor: "#4F196F", color: "#ffffff" }
                    : { backgroundColor: "#ffffff", color: "#4F196F" }
                }
                onClick={(ev) => {
                  ev.preventDefault();
                  this.handleTaskSelection("food");
                }}
              >
                Food
                <img
                  alt="unchecked"
                  src={SelectUnchecked}
                  style={{ display: this.state.isTaskFoodSelected ? "none" : "block" }}
                  className="selectUnchecked"
                />
                <img
                  alt="checked"
                  src={SelectChecked}
                  style={{ display: this.state.isTaskFoodSelected ? "block" : "none" }}
                  className="selectChecked"
                />
              </button>
            </div>
          </div>
          <div className="boxSelect">
            <div style={{ flex: "0 0 50%", position: "relative", textAlign: "center" }}>
              <button
                className="selectButton"
                style={
                  this.state.isTaskSocialIsolationSelected
                    ? { backgroundColor: "#4F196F", color: "#ffffff" }
                    : { backgroundColor: "#ffffff", color: "#4F196F" }
                }
                onClick={(ev) => {
                  ev.preventDefault();
                  this.handleTaskSelection("social isolation");
                }}
              >
                Social Isolation
                <img
                  alt="unchecked"
                  src={SelectUnchecked}
                  style={{ display: this.state.isTaskSocialIsolationSelected ? "none" : "block" }}
                  className="selectUnchecked"
                />
                <img
                  alt="checked"
                  src={SelectChecked}
                  style={{ display: this.state.isTaskSocialIsolationSelected ? "block" : "none" }}
                  className="selectChecked"
                />
              </button>
            </div>
            <div style={{ flex: "0 0 50%", position: "relative", textAlign: "center" }}>
              <button
                className="selectButton"
                style={
                  this.state.isTaskHospitalizationSelected
                    ? { backgroundColor: "#4F196F", color: "#ffffff" }
                    : { backgroundColor: "#ffffff", color: "#4F196F" }
                }
                onClick={(ev) => {
                  ev.preventDefault();
                  this.handleTaskSelection("recent hospitalization");
                }}
              >
                Recent
                <br />
                Hospitalization
                <img
                  alt="unchecked"
                  src={SelectUnchecked}
                  style={{ display: this.state.isTaskHospitalizationSelected ? "none" : "block" }}
                  className="selectUnchecked"
                />
                <img
                  alt="checked"
                  src={SelectChecked}
                  style={{ display: this.state.isTaskHospitalizationSelected ? "block" : "none" }}
                  className="selectChecked"
                />
              </button>
            </div>
          </div>

          <div>
            <label htmlFor="reason" className="field-label" style={{ paddingBottom: "10px", paddingTop: "10px" }}>
              Anything else you'd like us to know?
            </label>
            <textarea
              value={this.state.reason}
              onChange={this.handleChange}
              className="text-field memberinput w-input"
              style={Object.assign(
                { marginBottom: "0px", height: "auto", width: "100%", padding: "10px 15px" },
                this.errorHandler("reason")
              )}
              rows="3"
              placeholder="Ex. John needs help scheduling doctor's appointments."
              maxLength="512"
              name="reason"
              id="reason"
            />
          </div>
        </div>
      </div>
    );
  };

  doSubmit = (event) => {
    event.preventDefault();

    var combinedReason = "";
    if (this.state.isTaskTransportationSelected) combinedReason += "Transportation, ";
    if (this.state.isTaskFoodSelected) combinedReason += "Food, ";
    if (this.state.isTaskSocialIsolationSelected) combinedReason += "Social Isolation, ";
    if (this.state.isTaskHospitalizationSelected) combinedReason += "Recent Hospitalization, ";
    combinedReason += this.state.reason;
    combinedReason = combinedReason.replace(/(^[,\s]+)|([,\s]+$)/g, "");

    this.setState({ isSubmitting: true }, () => {
      var fields = {
        enrollmentType: "caremanager",
        caremanagerId: this.state.id,
        firstName: this.state.firstName.trim(),
        lastName: this.state.lastName.trim(),
        birthDay: this.state.birthDay.trim(),
        birthMonth: this.state.birthMonth.trim(),
        birthYear: this.state.birthYear.trim(),
        phone: this.state.phone.trim(),
        zipcode: this.state.zip.trim(),
        insuranceMemberId: this.state.memberId.trim(),
        insurancePlanName: this.state.planName.trim(),
        caregiverFirstName: this.state.caregiverFirstName.trim(),
        caregiverLastName: this.state.caregiverLastName.trim(),
        caregiverEmail: this.state.caregiverEmail.trim(),
        caregiverPhone: this.state.caregiverPhone.trim(),
        relationship: this.state.caregiverRelationship.trim(),
        reason: combinedReason.trim(),
      };
      api.caremanagerEnroll(fields).then((response) => {
        if (response.status === 200 || response.status === 201) {
          this.setState({ isSubmitting: false, showConfirmation: true });
        } else if (response.status === 400) {
          this.setState({ isSubmitting: false });
          var errList = {};
          for (var ii = 0; ii < response.body.length; ii++) {
            errList[response.body[ii].field] = true;
          }
          this.setState({ errors: errList });
        } else {
          this.setState({ isSubmitting: false, errorMessage: true });
        }
      });
    });
  };

  render() {
    var steps = ["Member Info", "Submit Referral"];
    var activeStep = 0;
    if (this.state.showConfirmation) {
      return (
        <div className="App confirmationBG">
          <Header />
          {this.sectionConfirmation()}
          <Footer confirmation={true} />
        </div>
      );
    } else {
      return (
        <div className="App" style={{ backgroundColor: "#f3f3f3" }}>
          <Header />

          <div className="section center small apply" style={{ paddingTop: "36px", height: "250px" }}>
            <div>
              <h1 style={{ marginTop: 0, marginBottom: "20px" }} className="paragraph purple apply">
                Refer a member to DUOS
              </h1>
            </div>
            <Stepper activeStep={activeStep} alternativeLabel style={{ backgroundColor: "transparent" }}>
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel style={{ color: "green !important" }}>{label}</StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>
          <form onSubmit={this.doSubmit}>
            {this.sectionMemberInformation()}
            {this.sectionCaregiverInformation()}
            {this.insuranceInformation()}
            {this.sectionTasks()}

            <div className="memberpod privacy">
              <div className="w-container">
                <div style={{ marginBottom: "35px" }}>
                  <button
                    type="submit"
                    className="button-hero sub purple w-button"
                    style={{ width: "100%" }}
                    disabled={this.state.isSubmitting}
                  >
                    <span style={{ display: this.state.isSubmitting ? "none" : "block" }}>Submit</span>
                    <svg
                      style={{ display: this.state.isSubmitting ? "block" : "none" }}
                      className="spinner"
                      version="1.1"
                      id="L9"
                      x="0px"
                      y="0px"
                      viewBox="0 0 100 100"
                      enableBackground="new 0 0 0 0"
                    >
                      <path
                        fill="#fff"
                        d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"
                      >
                        <animateTransform
                          attributeName="transform"
                          attributeType="XML"
                          type="rotate"
                          dur="1s"
                          from="0 50 50"
                          to="360 50 50"
                          repeatCount="indefinite"
                        />
                      </path>
                    </svg>
                  </button>
                  <p
                    style={{
                      display:
                        JSON.stringify(this.state.errors) !== "{}" && !this.state.errors?.inviteCode ? "block" : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    *Invalid values found in highlighted fields above, please fix and try again.
                  </p>
                  <p
                    style={{
                      display: this.state.errorMessage ? "block" : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    We are experiencing system issues at the moment, please try again later or give us a call. We
                    apologize for the inconvenience.
                  </p>
                  <p
                    style={{
                      display: this.state.errors?.inviteCode ? "block" : "none",
                      textAlign: "center",
                      color: "red",
                      fontWeight: "700",
                      marginTop: "10px",
                    }}
                  >
                    Invite code is no longer valid.
                  </p>
                </div>
                <div style={{ textAlign: "center" }}>
                  <p className="phoneBottomText">Call anytime to apply by phone</p>
                  <p>
                    <a href="tel:8552129242" className="telBottom">
                      855 212 9242
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </form>
          <Footer />
        </div>
      );
    }
  }
}

export default withRouter(Refer);
